import { render, staticRenderFns } from "./ClazzCard.vue?vue&type=template&id=fbea9252&"
import script from "./ClazzCard.vue?vue&type=script&lang=js&"
export * from "./ClazzCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports